import { render, staticRenderFns } from "./ContactListCreateOrEdit.vue?vue&type=template&id=f4b83872&"
import script from "./ContactListCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./ContactListCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContactListCreateOrEdit.vue?vue&type=style&index=0&id=f4b83872&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports